import { createNavigationContainerRef } from '@react-navigation/native'

export const navigationRef = createNavigationContainerRef()

const navigateWithTimeTracking = (screen: string, payload?: object) => {
  navigationRef.navigate(screen as never, (payload as never) || ({} as never))
}

export function navigateTo(name: string, params?: object) {
  if (navigationRef.isReady()) {
    navigateWithTimeTracking(name, params)
  }
}

export function resetNavigation(name: string) {
  if (navigationRef.isReady()) {
    const previousRouteName = navigationRef?.getCurrentRoute()?.name
    const currentRouteName = name
    if (previousRouteName !== currentRouteName) {
      navigationRef.reset({
        index: 0,
        routes: [{ name }],
      })
    }
  }
}

export function navigateBack() {
  if (navigationRef.isReady() && navigationRef.canGoBack()) {
    navigationRef.goBack()
  }
}
